import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const PolicyInactive: React.FC = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				margin: theme.spacing(2),
				padding: theme.spacing(2),
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				width: '100%',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
				}}
			>
				<CancelOutlinedIcon sx={{ fontSize: 60, color: theme.palette.error.main }} />
				<Typography variant='h6' sx={{ marginTop: theme.spacing(2), textAlign: 'center' }}>
					Your policy has expired. There are no payments due under this policy.
				</Typography>
			</Box>
		</Box>
	);
};

export default PolicyInactive;
